/**
 * A global namespace for predefined
 * CSS3 'cubic-bezier()' easing functions.
 */
const bezierEasings = {
  linear: "linear",
  easingSinusoidalIn: "cubic-bezier(0.47,0,0.745,0.715)",
  easingSinusoidalOut: "cubic-bezier(0.39,0.575,0.565,1)",
  easingSinusoidalInOut: "cubic-bezier(0.445,0.05,0.55,0.95)",
  easingQuadraticIn: "cubic-bezier(0.550,0.085,0.680,0.530)",
  easingQuadraticOut: "cubic-bezier(0.250,0.460,0.450,0.940)",
  easingQuadraticInOut: "cubic-bezier(0.455,0.030,0.515,0.955)",
  easingCubicIn: "cubic-bezier(0.55,0.055,0.675,0.19)",
  easingCubicOut: "cubic-bezier(0.215,0.61,0.355,1)",
  easingCubicInOut: "cubic-bezier(0.645,0.045,0.355,1)",
  easingQuarticIn: "cubic-bezier(0.895,0.03,0.685,0.22)",
  easingQuarticOut: "cubic-bezier(0.165,0.84,0.44,1)",
  easingQuarticInOut: "cubic-bezier(0.77,0,0.175,1)",
  easingQuinticIn: "cubic-bezier(0.755,0.05,0.855,0.06)",
  easingQuinticOut: "cubic-bezier(0.23,1,0.32,1)",
  easingQuinticInOut: "cubic-bezier(0.86,0,0.07,1)",
  easingExponentialIn: "cubic-bezier(0.95,0.05,0.795,0.035)",
  easingExponentialOut: "cubic-bezier(0.19,1,0.22,1)",
  easingExponentialInOut: "cubic-bezier(1,0,0,1)",
  easingCircularIn: "cubic-bezier(0.6,0.04,0.98,0.335)",
  easingCircularOut: "cubic-bezier(0.075,0.82,0.165,1)",
  easingCircularInOut: "cubic-bezier(0.785,0.135,0.15,0.86)",
  easingBackIn: "cubic-bezier(0.6,-0.28,0.735,0.045)",
  easingBackOut: "cubic-bezier(0.175,0.885,0.32,1.275)",
  easingBackInOut: "cubic-bezier(0.68,-0.55,0.265,1.55)",
};
export default bezierEasings;
